"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutSectionBorderMarker = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
exports.DashboardLayoutSectionBorderMarker = function (props) {
    var active = props.active, className = props.className;
    var background = active ? "var(--gd-palette-primary-base, " + sdk_ui_kit_1.GD_COLOR_HIGHLIGHT + ")" : "#E6E6E6";
    var color = active ? sdk_ui_kit_1.GD_COLOR_WHITE : sdk_ui_kit_1.INFO_TEXT_COLOR;
    return (react_1.default.createElement("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", className: className },
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("circle", { cx: "10", cy: "10", r: "10", fill: background }),
            react_1.default.createElement("path", { d: "M6.5 9.5H14c.2761424 0 .5.22385763.5.5 0 .2761424-.2238576.5-.5.5H6.5V14c0 .2761424-.22385763.5-.5.5-.27614237 0-.5-.2238576-.5-.5V6c0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5v3.5z", fill: color, fillRule: "nonzero" }))));
};
//# sourceMappingURL=DashboardLayoutSectionBorderMarker.js.map